// Phase A.4 / 8A.11 — Goal card rendered inline in chat.
//
// Uses the premium plan-card container with Playfair Display title,
// gold border, and proper SIKA token system.

interface GoalData {
  id?: string;
  title?: string;
  goal_category?: string;
  target_amount?: number;
  current_amount?: number;
  currency?: string;
  status?: string;
  timeline_weeks?: number | null;
  opening_stake?: number | null;
  risk_tolerance?: string | null;
}

function fmtAmt(n: number | undefined): string {
  if (n == null) return "—";
  return `GH₵ ${n.toLocaleString()}`;
}

export function SikaGoalCard({ data }: { data: unknown }): JSX.Element {
  const g = (data ?? {}) as GoalData;
  const target = Number(g.target_amount ?? 0);
  const current = Number(g.current_amount ?? 0);
  const pct = target > 0 ? Math.min(Math.round((current / target) * 100), 100) : 0;

  return (
    <div className="plan-card">
      <div className="plan-head">
        <div className="label">Goal Created</div>
        <div className="ttl">{g.title ?? "Untitled"}</div>
        {target > 0 && (
          <span className="target-amount">GH₵ {target.toLocaleString()}</span>
        )}
        <div className="meta">
          {g.goal_category ?? "—"} · {g.status ?? "draft"}
          {g.timeline_weeks != null ? ` · ${String(g.timeline_weeks)}w timeline` : ""}
        </div>
      </div>

      <div className="plan-stats">
        <div className="stat-row">
          <span className="stat-label">Target</span>
          <span className="stat-value">{fmtAmt(target)}</span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Progress</span>
          <span className="stat-value">{pct}%</span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Opening Stake</span>
          <span className="stat-value">
            {g.opening_stake != null ? fmtAmt(g.opening_stake) : "—"}
          </span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Risk tolerance</span>
          <span className="stat-value">{g.risk_tolerance ?? "moderate"}</span>
        </div>
      </div>

      {target > 0 && (
        <div className="ctx-progress-bar">
          <div className="ctx-progress-fill" style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
}
